<div class="continue-game-drawer" [ngStyle]="drawerStyles | theme">
  <div [ngClass]="glowClass"></div>
  <div class="continue-game-drawer-content">
    <div class="continue-game-drawer-content-info">
      <app-nav-button
        icon="close"
        (clickEvent)="onCloseClick()"
        [variant]="drawerConfig.closeButtonInverted ? 'secondary' : 'primary'"
        [size]="drawerConfig.closeButtonSize"
        [ngClass]="drawerConfig.closeButtonPosition"
      />

      @if (gameId(); as id) {
        <app-game-icon [game]="id" class="game-icon" />
      }

      @if (gameId(); as id) {
        <app-game-title [gameId]="id" [title]="gameName()" class="game-name" />
      }

      <div class="call-to-action" [ngStyle]="PaymentDrawerStyles.body | theme">
        {{ unfinishedGamelabel() }}
      </div>

      <app-countdown-pill
        [timeRemaining]="unfinishedTimeRemaining()"
        [size]="'small'"
        class="time-remaining"
      />
    </div>

    <app-button
      class="button"
      [label]="continueButtonLabel()"
      variant="primary"
      stretch="fill"
      (click)="onContinueClick()"
    />
  </div>
</div>
